var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GlobalLoader'),_c('div',{attrs:{"id":"page"}},[(_vm.$route.meta.showHeader)?_c('Header'):_vm._e(),_c('div',{attrs:{"id":"content"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }